enum ModalEvent {
  ok = 'ok',
  cancel = 'cancel',
  close = 'close',
  closeError = 'close-error',
  closeCallback = 'closeCallback'
}

export default ModalEvent;
